<template>
  <div class="topicMian">
    <div class="topic">
      <div style="font-weight: bold;font-size: 16px;">题目管理</div>
      <div style="margin-top: 20px;">
        <el-form :inline="true" :model="formInline" size="small">
          <el-form-item label="题目名称">
            <el-input style="width:300px;" @keyup.enter.native="search" v-model="formInline.title_str" placeholder="请输入题目名称" clearable></el-input>
          </el-form-item>

          <el-form-item label="Code值">
            <el-input style="width:300px;" @keyup.enter.native="search" v-model="formInline.code_other" placeholder="请输入题目code值" clearable></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="search">查询</el-button>

            <el-button type="primary" @click="Reset">重置</el-button>

            <el-button type="primary" @click="adminUpdateQuestionBulkOperateCode('1')">标记重复题</el-button>
            <!--
            <el-button
              type="primary"
              @click="adminUpdateQuestionBulkOperateCode('2')"
              >解绑题目</el-button
            >
            -->
          </el-form-item>

          <el-button plain icon="el-icon-caret-right" style="float:right" size="mini" v-if="isShow == false ? true : false" @click="changeAll">展开题目</el-button>
          <el-button plain icon="el-icon-caret-bottom" style="float:right" @click="changeAll1" size="mini" v-if="isShow == true ? true : false">收起题目</el-button>

          <br />

          <el-form-item label="题目来源">
            <el-select style="width:300px;" @change="changeSource" v-model="formInline.source_id" placeholder="请选择" clearable>
              <el-option v-for="item in testQuestionBankSourceList" :key="item.id" :label="item.title" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="赛道/分项">
            <el-select style="width:300px;" @change="search" :disabled="isShow3" v-model="formInline.source_tag_id" placeholder="请选择" clearable>
              <el-option v-for="item in testQuestionBankSourceTagList" :key="item.id" :label="item.title" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="年份">
            <el-select style="width:300px;" @change="search" v-model="formInline.year_id" placeholder="请选择" clearable>
              <el-option v-for="item in testQuestionBankYearList" :key="item.id" :label="item.title" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>

          <br />

          <el-form-item label="所属科目">
            <el-select style="width:200px;" @change="changeSubject" v-model="formInline.subject_id" placeholder="请选择" clearable>
              <el-option v-for="item in subject_list" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="知识分组">
            <el-select style="width:200px;" @change="adminGetTestQuestionTagList" v-model="formInline.question_group_id" placeholder="请选择" clearable filterable>
              <el-option v-for="item in testQuestionTagGroupList" :key="item.id" :label="item.title" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="知识点">
            <el-select style="width:200px;" @change="search" v-model="formInline.question_tag_id" placeholder="请选择" clearable filterable>
              <el-option v-for="item in testQuestionTagList" :key="item.id" :label="item.title" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="">
            <el-checkbox @change="search" v-model="formInline.exclude_duplication">过滤重复题</el-checkbox>
          </el-form-item>

          <br />

          <el-form-item label="题目类型">
            <el-radio-group @change="search" v-model="formInline.type">
              <el-radio label="">全部</el-radio>
              <el-radio label="1">单选题</el-radio>
              <el-radio label="2">多选题</el-radio>
              <el-radio label="3">判断题</el-radio>
              <el-radio label="4">填空题</el-radio>
              <el-radio label="5">简答题</el-radio>
              <el-radio label="6">综合题</el-radio>
              <el-radio label="7">阅读程序</el-radio>
              <el-radio label="8">完善程序</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
      <div>
        <el-table :row-key="(row) => row.id" :expand-row-keys="expandedRows" :header-cell-style="{
            background: '#f5f7fa',
            color: '#606266',
            'font-size': '14px',
          }" stripe :data="tableData" style="width: 100%;" @selection-change="handleSelectionChange">
          <el-table-column type="expand">
            <template slot-scope="props">
              <div style="padding:20px;">
                <div v-if="props.row.show_type === 1">
                  <div class="question_title" v-html="props.row.title"></div>
                </div>
                <div class="question_title" v-else>
                  <mavon-editor :style="{ 'min-height': '0px' }" preview-background="#fff" v-model="props.row.title_md" defaultOpen="preview" :boxShadow="false" :editable="false" :subfield="false" :toolbarsFlag="false"></mavon-editor>
                </div>

                <div v-if="props.row.show_type === 1">
                  <div class="options" v-for="(item, index) of JSON.parse(props.row.options)" :key="index">
                    <div v-if="props.row.type != '6'">
                      <div v-if="item.content" class="options_title">
                        {{ item.title }}
                      </div>

                      <div v-if="item.content" class="options_content">
                        <div class="content" v-html="item.content"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <div v-if="props.row.type == '3'">
                    <div class="options" v-for="(item, index) of JSON.parse(props.row.options)" :key="index">
                      <div v-if="item.content" class="options_title">
                        {{ item.title }}
                      </div>

                      <div v-if="item.content" class="options_content">
                        <div class="content" v-html="item.content"></div>
                      </div>
                    </div>
                  </div>
                  <div v-else class="options" v-for="(item, index) of JSON.parse(props.row.options_md)" :key="index">
                    <div v-if="item.content" class="options_title">
                      {{ item.title }}
                    </div>

                    <div v-if="item.content" class="options_content">
                      <div class="content">
                        <mavon-editor :style="{ 'min-height': '0px' }" preview-background="#F5F7FC" v-model="item.content" defaultOpen="preview" :boxShadow="false" :editable="false" :subfield="false" :toolbarsFlag="false"></mavon-editor>
                      </div>
                    </div>
                  </div>
                </div>
                <div style="margin-top: 10px;">
                  <div class="answer_label">正确答案:</div>
                  <div v-if="
                      props.row.type == '1' ||
                        props.row.type == '2' ||
                        props.row.type == '3' ||
                        props.row.type == '4' ||
                        props.row.type == '7' ||
                        props.row.type == '8'
                    " class="answer_content" v-html="props.row.answer"></div>
                  <div v-else-if="props.row.type == '5'">简答题答案</div>
                  <div v-else-if="props.row.type == '6'">综合题答案</div>
                </div>

                <div style="margin-top: 10px;">
                  <div class="answer_label">试题解析:</div>
                  <div v-if="props.row.show_type === 1" class="answer_content" v-html="props.row.analysis"></div>
                  <div v-else class="answer_content">
                    <mavon-editor :style="{ 'min-height': '0px' }" preview-background="#fff" v-model="props.row.analysis_md" defaultOpen="preview" :boxShadow="false" :editable="false" :subfield="false" :toolbarsFlag="false"></mavon-editor>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column type="selection" width="55"> </el-table-column>

          <el-table-column label="题干描述" width="200" v-if="formInline.type == 7 || formInline.type == 8">
            <template slot-scope="scope">
              <div v-if="scope.row.title_other_md" class="ellipsis" v-html="scope.row.title_other_md"></div>
              <div v-else>--</div>
            </template>
          </el-table-column>

          <el-table-column label="题目名称">
            <template slot-scope="scope">
              <div class="ellipsis" v-html="scope.row.title_str"></div>
            </template>
          </el-table-column>

          <el-table-column label="题型" width="150">
            <template slot-scope="scope">
              <span v-if="scope.row.type == 1">单选</span>
              <span v-if="scope.row.type == 2">多选</span>
              <span v-if="scope.row.type == 3">判断</span>
              <span v-if="scope.row.type == 4">填空</span>
              <span v-if="scope.row.type == 5">简答</span>
              <span v-if="scope.row.type == 6">综合题</span>
              <span v-if="scope.row.type == 7">阅读程序</span>
              <span v-if="scope.row.type == 8">完善程序</span>
            </template>
          </el-table-column>

          <el-table-column label="知识点" width="150px">
            <template slot-scope="scope">
              <span v-if="scope.row.tagTitleStr">{{
                scope.row.tagTitleStr
              }}</span>
              <span v-else>暂无</span>
            </template>
          </el-table-column>

          <el-table-column label="所属题库" width="150">
            <template slot-scope="scope">
              <el-popover placement="top-start" :title="scope.row.bankInfo.title" trigger="hover" :content="
                  '来源:' +
                    (scope.row.bankInfo.sourceTitle
                      ? scope.row.bankInfo.sourceTitle
                      : '--') +
                    ' 年份:' +
                    (scope.row.bankInfo.yearTitle
                      ? scope.row.bankInfo.yearTitle
                      : '--') +
                    ' 科目:' +
                    scope.row.subjectName
                ">
                <span slot="reference">{{ scope.row.bankInfo.title }}</span>
              </el-popover>
            </template>
          </el-table-column>

          <el-table-column label="Code" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.code_other">
                {{ scope.row.code_other}}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>

          <el-table-column label="重复题标记" width="150">
            <template slot-scope="scope">
              {{ scope.row.bulk_operate_code }}
              <i v-if="scope.row.bulk_operate_code" style="cursor: pointer;" class="el-icon-delete" @click="ClearCode(scope.row.id)"></i>
            </template>
          </el-table-column>

          <el-table-column fixed="right" align="center" label="操作" width="100">
            <!-- slot-scope="scope" -->
            <template slot-scope="scope">
              <!-- <el-link type="primary" @click="EditQuestion(scope.row)"
                                    v-if="scope.row.type == 7 || scope.row.type == 8">操作</el-link> -->
              <!-- <span v-else> -->
              <el-link type="primary" @click="EditQuestion(scope.row)">编辑</el-link>
              <el-link style="margin-left: 10px;" type="primary" @click="DeleteQuestion(scope.row.id)">删除</el-link>
              <!-- </span> -->
            </template>
          </el-table-column>
        </el-table>
        <div style="text-align: right; margin-top: 5px;">
          <el-pagination @current-change="handleCurrentChange" :current-page.sync="formInline.page_no" layout="total, prev, pager, next" :total="formInline.total" :page-size="formInline.page_size"></el-pagination>
        </div>
      </div>
    </div>
    <el-drawer title="知识点标签" :wrapperClosable="false" :visible.sync="drawer" :before-close="handleClose">
      <div style="padding: 20px;" class="tableStyle">
        <span>
          <span class="el-icon-plus" style="color: #409EFF;"></span>
          <span><el-button type="text" @click="addLable">添加标签</el-button></span></span>
        <el-table :header-cell-style="{ background: '#f5f7fa' }" row-key="id" :data="tableData1" stripe style="width: 100%;margin-top: 20px;" size="mini">
          <el-table-column prop="date" label="序号"> </el-table-column>
          <el-table-column prop="name" label="名称"> </el-table-column>
          <el-table-column prop="address" label="操作">
            <template>
              <el-button type="text">删除</el-button>
              <el-button type="text">编辑</el-button>
              <i class="el-icon-rank" style="margin-left:20px; cursor: pointer;color: #409EFF;"></i>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-drawer>
    <el-dialog title="标签" :visible.sync="dialogVisible" width="50%" :before-close="handleCloseLable">
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="排序号">
          <el-input-number v-model="form.num" :precision="2" :step="0.1"></el-input-number>
        </el-form-item>
        <el-form-item label="名称">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import Sortable from "sortablejs";
import {
  adminGetTestQuestionList,
  adminGetTestQuestionBankSourceListWit,
  adminGetTestQuestionBankSourceTagListWithoutPage,
  getSubjectList,
  adminGetTestQuestionBankYearListWithoutPage,
  adminGetTestQuestionTagListWithoutPage,
  adminDeleteQuestion,
  adminGetTestQuestionTagGroupListWithoutPage,
  adminGetTestQuestionTagList,
  adminUpdateQuestionBulkOperateCode,
} from "@/api/admin.js";
export default {
  data() {
    return {
      isShow1: true,
      isShow2: true,
      isShow3: true,
      testQuestionBankSourceList: [],
      testQuestionBankSourceTagList: [],
      testQuestionBankYearList: [],
      testQuestionTagList: [],
      subject_list: [],
      form: {
        num: 0,
        name: "",
      },
      dialogVisible: false,
      tableData1: [],
      drawer: false,
      isShow: false,
      type: [
        {
          id: 1,
          title: "单选",
        },
        {
          id: 2,
          title: "多选",
        },
        {
          id: 3,
          title: "判断",
        },
        {
          id: 4,
          title: "填空",
        },
        {
          id: 5,
          title: "简答",
        },
        {
          id: 6,
          title: "综合题",
        },
        {
          id: 7,
          title: "阅读程序",
        },
        {
          id: 8,
          title: "完善程序",
        },
      ],
      options: [],
      testQuestionTagGroupList: [],
      formInline: {
        subject_id: "",
        question_group_id: "",
        question_tag_id: "",
        type: "",
        page_no: 1,
        page_size: 20,
        total: 0,
        code_other: "",
        exclude_duplication: true

      },
      tableData: [],
      expandedRows: [],
      questionArr: [],
    };
  },

  mounted() {
    console.log("默认筛选条件");
    console.log(sessionStorage.getItem("testing_topic_formInline"));

    if (JSON.parse(sessionStorage.getItem("testing_topic_formInline"))) {
      this.formInline = JSON.parse(
        sessionStorage.getItem("testing_topic_formInline")
      );
    }

    this.adminGetTestQuestionList();
    this.adminGetTestQuestionBankSourceListWit();
    this.adminGetTestQuestionBankYearListWithoutPage();
    this.adminGetTestQuestionTagGroupListWithoutPage();
    this.getSubjectList();
    this.adminGetTestQuestionTagList();
  },
  watch: {
    formInline: {
      handler(newVal, oldVal) {
        // 当 formInline 对象的任何属性发生变化时执行的回调函数
        console.log("formInline 值发生变化", newVal, oldVal);

        console.log("新值");
        console.log(newVal);

        sessionStorage.setItem(
          "testing_topic_formInline",
          JSON.stringify(newVal)
        );
      },
      deep: true, // 开启深度监听，用于监听 formInline 对象属性的值变化
    },
  },
  methods: {
    Reset() {
      (this.formInline = {
        subject_id: "",
        question_group_id: "",
        question_tag_id: "",
        type: "",
      }),
        sessionStorage.setItem(
          "testing_topic_formInline",
          JSON.stringify(this.formInline)
        );

      this.search();
    },

    handleSelectionChange(val) {
      console.log("绑定/解绑题目");
      console.log(val);

      this.questionArr = [];

      for (let i = 0; i < val.length; i++) {
        this.questionArr.push(val[i].id);
      }

      console.log("当前题目IDS");
      console.log(this.questionArr);
    },

    ClearCode(id) {
      this.questionArr = [];
      this.questionArr.push(id);
      this.adminUpdateQuestionBulkOperateCode("2");
    },

    //绑定/解绑题目
    adminUpdateQuestionBulkOperateCode(type) {
      console.log("操作类型 ->" + type);
      console.log("当前ID组 ->" + this.questionArr);

      if (this.questionArr.length == 0) {
        this.$message.warning("请选择重复的题目");
        return;
      }

      adminUpdateQuestionBulkOperateCode({
        questionIdArr: JSON.stringify(this.questionArr),
        operateType: type,
      }).then((res) => {
        console.log(res);
        if (res.is_update) {
          if (type == "1") {
            this.$message.success("绑定成功");
          } else {
            this.$message.success("解除绑定");
          }

          this.adminGetTestQuestionList();
        }
      });
    },

    //查询知识点
    adminGetTestQuestionTagList() {
      adminGetTestQuestionTagList({
        title: "",
        group_id: this.formInline.question_group_id,
        page_no: 1,
        page_size: 1000,
      }).then((res) => {
        console.log("知识点");
        console.log(res);
        this.testQuestionTagList = res.TestQuestionTagList;

        if (this.testQuestionTagList.length > 0) {
          this.isShow2 = false;
        }
      });
    },

    //分项
    adminGetTestQuestionBankSourceTagListWithoutPage() {
      adminGetTestQuestionBankSourceTagListWithoutPage({
        source_id: this.formInline.source_id,
      }).then((res) => {
        this.testQuestionBankSourceTagList = res.testQuestionBankSourceTagList;
      });
    },
    changeSource(val) {
      if (val == "") {
        this.isShow3 = true;
        this.formInline.source_id = "";
      } else {
        this.isShow3 = false;
      }
      console.log(val, 78974465);
      this.formInline.source_id = val;
      this.adminGetTestQuestionList();
      this.adminGetTestQuestionBankSourceTagListWithoutPage();
    },
    changeSubject(val) {
      this.formInline.subject_id = val;
      this.adminGetTestQuestionTagGroupListWithoutPage();
    },
    changequestion(val) {
      if (val == "") {
        this.isShow2 = true;
      } else {
        this.isShow2 = false;
      }
      this.formInline.question_group_id = val;
      this.adminGetTestQuestionTagListWithoutPage();
    },
    //知识点
    adminGetTestQuestionTagListWithoutPage() {
      adminGetTestQuestionTagListWithoutPage({
        group_id: this.formInline.question_group_id,
      }).then((res) => {
        console.log(res, 789655);
        this.testQuestionTagList = res.testQuestionTagList;
      });
    },
    adminGetTestQuestionTagGroupListWithoutPage() {
      adminGetTestQuestionTagGroupListWithoutPage({
        subject_id: this.formInline.subject_id,
      }).then((res) => {
        console.log(res, 798465);
        this.testQuestionTagGroupList = res.testQuestionTagGroupList;

        this.adminGetTestQuestionList();
      });
    },
    // adminGetTestQuestionTagGroupListWithoutPage
    // 行拖拽
    rowDrop() {
      // 要侦听拖拽响应的DOM对象
      const tbody = document.querySelector(
        ".tableStyle .el-table__body-wrapper tbody"
      );
      const that = this;
      console.log(that.tableData1, 4547878);
      Sortable.create(tbody, {
        animation: 1000,
        ghostClass: "ghostClass", //设置拖拽停靠样式类名
        chosenClass: "chosenClass", //设置选中样式类名
        handle: ".el-icon-rank",
        // 结束拖拽后的回调函数
        onEnd({ newIndex, oldIndex }) {
          console.log("拖动了行，当前序号：" + newIndex);
          const currentRow = that.tableData1.splice(oldIndex, 1)[0];
          that.tableData1.splice(newIndex, 0, currentRow);
          console.log(that.tableData1, 4578);
        },
      });
    },
    DeleteQuestion(id) {
      console.log("删除题目");
      console.log(id);

      this.$confirm("确定删除本道题吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        adminDeleteQuestion({
          questionId: id,
        }).then((res) => {
          console.log("删除题目");
          console.log(res);
          if (res.is_delete) {
            this.$message.success("删除成功");
            this.adminGetTestQuestionList();
          }
        });
      });
    },
    EditQuestion(row) {
      console.log("编辑题目");
      console.log(row, 123465);

      this.$router.push({
        name: "newQuestion",
        query: {
          id: row.quesiont_bank_id,
          title: this.title,
          subject_id: row.subject_id,
          schoolId: row.educational_institution_id,
          type: "3",
          question_num: row.sort_num,
          code_other: row.code_other,
          typeIndex: 1,
          state: "编辑题目",
        },
        params: {
          question: row,
        },
      });
      sessionStorage.setItem("ExamData", JSON.stringify(row));
    },
    //重置
    resetting() {
      this.formInline.title_str = "";
      this.formInline.source_id = "";
      this.formInline.source_tag_id = "";
      this.formInline.year_id = "";
      // this.formInline.question_group_id = ''
      this.formInline.question_tag_id = "";
      this.formInline.type = "";
      this.formInline.subject_id = "";
      this.formInline.code_other = "";
      this.formInline.exclude_duplication = true;
      this.search();
    },

    //年份
    adminGetTestQuestionBankYearListWithoutPage() {
      adminGetTestQuestionBankYearListWithoutPage().then((res) => {
        console.log(res, 123465798);
        this.testQuestionBankYearList = res.testQuestionBankYearList;
      });
    },
    //科目
    getSubjectList() {
      getSubjectList({
        page_no: 1,
        page_size: 100,
      }).then((res) => {
        this.subject_list = res.subject_list;
      });
    },

    //题库来源
    adminGetTestQuestionBankSourceListWit() {
      adminGetTestQuestionBankSourceListWit().then((res) => {
        this.testQuestionBankSourceList = res.testQuestionBankSourceList;
      });
    },
    handleCurrentChange(val) {
      this.isShow = false;
      this.expandedRows = [];
      this.formInline.page_no = val;
      this.adminGetTestQuestionList();
    },
    search() {
      this.formInline.page_no = 1;
      this.adminGetTestQuestionList();
    },
    adminGetTestQuestionList() {
      adminGetTestQuestionList({
        is_admin: this.formInline.is_admin,
        title_str: this.formInline.title_str,
        source_id: this.formInline.source_id,
        source_tag_id: this.formInline.source_tag_id,
        year_id: this.formInline.year_id,
        subject_id: this.formInline.subject_id,
        question_group_id: this.formInline.question_group_id,
        question_tag_id: this.formInline.question_tag_id,
        type: this.formInline.type,
        code_other: this.formInline.code_other,
        if_filter: this.formInline.exclude_duplication,
        page_no: this.formInline.page_no,
        page_size: this.formInline.page_size,
      }).then((res) => {
        this.tableData = res.questionList;
        this.formInline.total = res.total;
        console.log(res, 123456);
      });
    },
    changeAll() {
      this.isShow = true;
      this.expandedRows = this.tableData.map((row) => row.id);
    },
    changeAll1() {
      this.isShow = false;
      this.expandedRows = [];
    },
    KnowledgeBtn() {
      this.drawer = true;
      this.$nextTick(() => {
        this.rowDrop();
      });
    },
    handleClose() {
      this.drawer = false;
    },
    handleCloseLable() {
      this.dialogVisible = false;
    },
    addLable() {
      this.dialogVisible = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.answer_content {
  margin-top: 0px;
}

.options {
  overflow: hidden;
  width: 100%;
  // padding: 15px;
  border-radius: 5px;
  background-color: #f5f7fc;
  margin-top: 15px;
}

.options_title {
  border-radius: 50%;
  background: #fff;
  float: left;
  text-align: center;
  width: 35px;
  height: 35px;
  line-height: 34px;
  margin: 10px;
}

.options_content {
  float: left;
  margin-left: 10px;
  line-height: 35px;
  margin: 10px 0px;
}

.question_title {
  font-weight: bold;
  font-size: 16px;
  color: #919499;
}

.topicMian {
  padding: 10px;
}

.topic {
  background: white;
  border-radius: 5px;
  min-height: calc(100vh - 110px);
  width: 100%;
  padding: 25px;
  box-sizing: border-box;
}

.ellipsis {
  display: -webkit-box;
  -webkit-line-clamp: 5; /* 控制显示的最大行数 */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.answer_label {
  font-weight: bold;
}

.fl {
  float: left;
}

.fr {
  float: right;
}

/deep/ .v-note-wrapper {
  border: 0px;
}

/deep/ .v-note-wrapper .v-note-panel .v-note-show .v-show-content,
.v-note-wrapper .v-note-panel .v-note-show .v-show-content-html {
  padding: 0;
}
</style>
<style>
.topicMian .el-drawer__header {
  margin-bottom: 0px;
}
</style>
